/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

(function (Drupal, $) {
  Drupal.behaviors.gridMenu = {
    attach: function (context) {
      'use strict';

      $('.grid-menu', context).once('grid-menu-folding').addClass("grid-menu-folding").each(function () {

        $(this).find('> li > .expand-sub').on('click',function(){
          $(this).toggleClass('expand-sub--open');
          $(this).parent().find('> ul').slideToggle(500);
        });
      });

    }
  }
})(Drupal, jQuery);
